export const JOBS = [
    {
        id: '0',
        company: 'iManage',
        position: 'Lead Software Engineer and Senior Software Engineer',
        dates: 'May 2021 - Present',
        logoUrl: 'imanage.png',
        details: [
            "Lead the technical direction for full-stack and React Native (iOS & Android) apps, taking ownership of app quality, performance, and release readiness from initial design through to production.",
            "Collaborate daily with a close-knit, cross-functional team of engineers, designers, and product managers to build and refine features.",
            "Champion the use of agent-driven AI workflows (using Claude Code) to handle complex refactoring, write tests, and speed up our overall development cycle.",
            "Set up and manage automated CI/CD pipelines in GitHub Actions, which took the friction out of our deployments and made releases much more reliable.",
            "Led the development of complex REST API integrations with our partners, directly supporting the successful onboarding of over 20 new enterprise clients.",
            "Noticed the team was wasting time manually syncing icons with design specs, so I built a custom internal tool to automate the workflow and save everyone hours of repetitive work."
        ]
    },
    {
        id: '1',
        company: 'Rogers Communications Inc.',
        position: 'Sr. Frontend Developer and Frontend Developer',
        dates: 'July 2018 - May 2021',
        logoUrl: 'rogers.svg',
        details: [
            "Developed user-focused features for the MyRogers and MyFido React Native apps, as well as full-stack web improvements for Rogers.com and Fido.ca, reaching millions of customers nationwide.",
            "Engineered resilient mobile networking features, managing complex offline behaviors, app lifecycles, and unreliable network conditions to maintain application stability for mobile users.",
            "Worked hand-in-hand with the design team to build clean, engaging UI components that helped keep users actively engaged in our online buy flows.",
            "Managed large-scale, cross-team code releases, taking responsibility for making sure production deployments went smoothly and without bugs."
        ]
    },
    {
        id: '2',
        company: 'Elavon Inc.',
        position: 'Software Engineer Intern',
        dates: 'May 2017 - August 2017',
        logoUrl: 'elavon.jpg',
        details: [
            "Joined the core development team as a junior full-stack engineer to build a greenfield project from the ground up.",
            "Helped secure additional project funding within the first month by demonstrating early technical progress.",
            "Delivered the full MVP, including QA testing, by the end of the internship.",
        ]
    },
]

export const APPS = [
    {
        id: '0',
        name: 'Shut the Box Daily',
        icon: '/app-icons/stb.png',
        description: 'My spin on the classic board game!',
        published: true,
        appStoreLink: 'https://apps.apple.com/ca/app/shut-the-box-daily/id6496852924',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.dmarchese.shutthebox&hl=en',
        pageLink: '/stb-daily'
    },
    {
        id: '1',
        name: 'Canadian GFA Viewer',
        icon: '/app-icons/gfa.png',
        description: 'Easily check GFA Clouds and Icing maps. 100+ WAU!',
        published: true,
        appStoreLink: 'https://apps.apple.com/ca/app/canadian-gfa-viewer/id6447487574',
        pageLink: '/gfa-viewer'
    },
    {
        id: '2',
        name: 'Freida McFadden Hub',
        icon: '/app-icons/fmh.png',
        description: "A hub for all things Freida McFadden, the bestselling author of psychological thrillers. Built for her fans to easily track their reading progress and discuss theories with other fans.",
        published: false,
        appStoreLink: '',
        pageLink: '/freida-mcfadden-hub'
    },
]